import React from "react";
import { SearchProps } from "@usereactify/search";
import { search } from "../../../react-hooks/svgIcons";

export type SearchInputProps = React.ComponentProps<
    NonNullable<SearchProps["render"]>
>;

export const SearchInput: React.FC<SearchInputProps> = (props) => {

    const handleFormSubmit = React.useCallback(
        (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            props.submitSearchTerm();
        },
        [props.submitSearchTerm]
    );

    const handleInputChange = React.useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            props.setSearchTerm(event.target.value);
        },
        [props.setSearchTerm]
    );

    return (
        <form onSubmit={handleFormSubmit}>
            <div className="header-search__form-control flex justify-between">
                <div className="gap-2 flex align-center w-full relative">
                    <input
                        type="search"
                        placeholder="Search for..."
                        value={props.searchTerm}
                        onChange={handleInputChange}
                        className="header-search__input w-full"
                    />
                    <button type="submit" className="search-input__icon absolute" aria-label="Search">{search}</button>
                </div>
            </div>
        </form>
    );
};
